import { motion } from "framer-motion";

const ease = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 28, className = "", as = "div" }) => {
  const M = motion[as];
  return (
    <M
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.12 }}
      transition={{ duration: 0.8, delay, ease }}
    >
      {children}
    </M>
  );
};

export const MaskLines = ({ lines, className = "", delay = 0.1, step = 0.12 }) => (
  <span className={className}>
    {lines.map((line, i) => (
      <span key={i} className="block overflow-hidden pb-[0.12em] -mb-[0.12em]">
        <motion.span
          className="block will-change-transform"
          initial={{ y: "105%" }}
          animate={{ y: "0%" }}
          transition={{ duration: 1.05, delay: delay + i * step, ease }}
        >
          {line}
        </motion.span>
      </span>
    ))}
  </span>
);
